import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CssBaseline from '@mui/material/CssBaseline';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import { StyledEngineProvider, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { theme as classTheme } from './theme';
export const ClassThemeProvider = (props) => {
    const { theme = 'light', cssReset = 'global', children } = props;
    return (_jsx(StyledEngineProvider, { injectFirst: true, children: _jsxs(MuiThemeProvider, { theme: classTheme(theme), children: [cssReset === 'global' && _jsx(CssBaseline, {}), cssReset === 'scoped' && _jsx(ScopedCssBaseline, {}), children] }) }));
};
